function LibertyIcon2() {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.271484" width="24" height="20" rx="4" fill="#05010B" />
      <path
        d="M3.67234 11.119V11.999H1.27148V7.99902H2.2084V11.119H3.67234Z"
        fill="white"
      />
      <path d="M5.31778 7.99896H4.38086V11.999H5.31778V7.99896Z" fill="white" />
      <path
        d="M8.17064 9.92484C8.28576 9.82823 8.37751 9.7079 8.43925 9.57252C8.50099 9.43714 8.5312 9.29009 8.5277 9.14194C8.5277 8.45014 7.94785 7.99896 7.23372 7.99896H6.02734V8.85835H7.23372C7.45033 8.85835 7.59078 9.00659 7.59078 9.21241C7.59319 9.25907 7.58564 9.30571 7.56863 9.34938C7.55162 9.39305 7.5255 9.4328 7.49195 9.46612C7.45839 9.49944 7.41811 9.5256 7.37366 9.54294C7.32921 9.56029 7.28156 9.56845 7.23372 9.56691H6.71374V10.376H7.35083C7.58506 10.376 7.7374 10.5363 7.7374 10.7589C7.7374 10.9815 7.58506 11.1417 7.35083 11.1417H6.71374V12.0011H7.35083C8.08258 12.0011 8.67388 11.5383 8.67388 10.8298C8.67812 10.6496 8.63389 10.4714 8.54559 10.3131C8.45729 10.1548 8.32801 10.0218 8.17064 9.92742"
        fill="#E03126"
      />
      <path
        d="M11.9711 11.119V11.999H9.39453V7.99896H11.942V8.87897H10.3315V9.54199H11.7954V10.4104H10.3315V11.119H11.9711Z"
        fill="white"
      />
      <path
        d="M18.986 8.87897H17.9319V11.999H16.9954V8.87897H15.9414V7.99896H18.986V8.87897Z"
        fill="white"
      />
      <path
        d="M21.8953 10.4615V11.999H20.9584V10.4615L19.582 7.99896H20.648L21.4268 9.54199L22.2052 7.99896H23.2712L21.8953 10.4615Z"
        fill="white"
      />
      <path
        d="M14.483 10.5303C14.9338 10.3077 15.2381 9.86168 15.2381 9.37011C15.2385 9.18992 15.2025 9.01142 15.1321 8.84486C15.0616 8.6783 14.9582 8.52697 14.8276 8.39955C14.6971 8.27214 14.542 8.17116 14.3713 8.10242C14.2007 8.03367 14.0178 7.99851 13.8331 7.99897H12.625V8.85577H13.8331C14.0907 8.85577 14.3016 9.07878 14.3016 9.3714C14.3016 9.66402 14.0907 9.88703 13.8331 9.88703H13.2321V10.6845H13.5751L14.3487 11.999H15.3561L14.483 10.5303Z"
        fill="white"
      />
    </svg>
  );
}

export default LibertyIcon2;
